/**
 * entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import { globalVar } from '@/helpers/globals';
import { statusMap } from '@/models/Address';
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';
import dayjs from 'dayjs';

export class EventOrganizer extends BaseModel {
    defaults() {
        return {
            // properties
            id: null,
            uuid: null,
            standard_text_tickets: null,
            ticketprices: null,
            is_enabled: null,
            address_id: null,
            featured_image_id: null,
            featured_img_crop_config: null,
            status: null,
            is_visible: null,
            rejected_reason: null,
            bp_import_id: null,
            bp_import_date: null,
            bp_import_origin: null,
            created: null,
            modified: null,
            creator_id: null,
            modifier_id: null,
            default_location_id: null,
            active_reduction: null,

            // address view fields
            legal_type: null,
            address_uuid: null,
            title: null,
            first_name: null,
            surname: null,
            description: null,
            tel: null,
            mobile: null,
            email: null,
            web: null,
            social_media: null,
            address_supplement: null,
            address: null,
            po_box: null,
            zip: null,
            city: null,
            mailing_list_ids: null,
            mailing_list_names: null,
            organizer_group_id: null,
            category_ids: null,
            categories_texts: null,
            country_id: null,
            country_name: null,
            tags: null,
            tag_names: null,
            infomail_tgk: null,
            infomail_tgk_date: null,
            import_protection: null,

            // own view fields
            creator: null,
            creator_role: null,
            modifier: null,
            modifier_role: null,
            status_in_union_mail_sent: null,
            status_rejected_mail_sent: null,
            status_in_union_sender_id: null,
            status_rejected_sender_id: null,
            status_in_union_sender: null,
            status_rejected_sender: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            created: dayjs,
            modified: dayjs,
            status_in_union_mail_sent: dayjs,
            status_rejected_mail_sent: dayjs,
            infomail_tgk_date: dayjs,
            is_visible: Boolean,
            infomail_tgk: Boolean,
            address_id: Number,
            country_id: Number,
            creator_id: Number,
            modifier_id: Number,
            status_in_union_sender_id: Number,
            status_rejected_sender_id: Number,
        };
    }

    entityName() {
        return 'EventOrganizer';
    }

    get displayTitle() {
        if (this.first_name || this.surname) {
            let ret = `${this.first_name} ${this.surname}`;
            if (this.title) {
                ret += ` (${this.title})`;
            }
            return ret || '- kein Titel -';
        } else {
            return this.title || '- kein Titel -';
        }
    }

    get is_imported() {
        return this.bp_import_id > 0;
    }

    get humanReadableStatus() {
        const status = this.get('status');
        if (status && statusMap[status]) {
            return statusMap[status].text;
        } else {
            return 'neu';
        }
    }

    get status_icon() {
        const status = this.get('status');
        if (status && statusMap[status]) {
            return statusMap[status].icon;
        } else {
            return '';
        }
    }

    get status_icon_color() {
        const status = this.get('status');
        if (status && statusMap[status]) {
            return statusMap[status].icon_color;
        } else {
            return '';
        }
    }

    get type() {
        return 'event_organizer';
    }

    get thumbImageUrl() {
        if (!this.featured_image_id) {
            return null;
        }
        let id = this.id;
        let conf = globalVar('featured_images_config').organizer.thumb;
        return `${globalVar('imageroot')}/organizer/${id}/${conf.ident}.${conf.format}`;
    }
}

export class EventOrganizerCollection extends BaseCollection {
    options() {
        return {
            model: EventOrganizer,
        };
    }

    entityName() {
        return 'EventOrganizer';
    }
}
